import { CustomerState } from "../customer.slice.ts";
import { PayloadAction } from "@reduxjs/toolkit";
import { GetOrchSurveyResponse } from "../../../../orchestrator-api-client";

export const coherenceQuestionnaireReducer = (
  state: CustomerState,
  action: PayloadAction<GetOrchSurveyResponse>,
) => {
  state.cpiQuestionnaire = action.payload;
};
